export var testAudioBufferCopyChannelMethodsSubarraySupport = function testAudioBufferCopyChannelMethodsSubarraySupport(nativeAudioBuffer) {
  var source = new Float32Array(2);

  try {
    /*
     * Only Firefox does not fully support the copyFromChannel() and copyToChannel() methods. Therefore testing one of those
     * methods is enough to know if the other one it supported as well.
     */
    nativeAudioBuffer.copyToChannel(source, 0, nativeAudioBuffer.length - 1);
  } catch (_a) {
    return false;
  }

  return true;
};